import type { AppEnv } from '@hc-frontend/core-context';
import { getClientApplicationConfig } from '@hc-frontend/core-context';

const pivothealthComLinkRegex = /^(www\.)?((stg|qa)\.)?pivothealth\.com/;

export function isPivothealthComLink(url: URL) {
  return pivothealthComLinkRegex.test(url.hostname);
}

const hostnameMap: Record<AppEnv, string> = {
  local: 'qa.pivothealth.com',
  dev: 'stg.pivothealth.com',
  qa: 'qa.pivothealth.com',
  stg: 'www.stg.pivothealth.com',
  prd: 'www.pivothealth.com',
};

export function checkPivothealthComLink(url: URL): string {
  const config = getClientApplicationConfig();

  url.hostname = hostnameMap[config.core.appEnvironment];
  return decodeURIComponent(url.href);
}
